import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    preguntas: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_PREGUNTAS = 'GET_ALL_PREGUNTAS'
const GET_ALL_PREGUNTAS_BY_CUESTIONARIO = 'GET_ALL_PREGUNTAS_BY_CUESTIONARIO'
const GET_CUESTIONARIO_BY_ID = 'GET_CUESTIONARIO_BY_ID'
const UPDATE_CUESTIONARIO = 'UPDATE_CUESTIONARIO'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllPreguntas = createAsyncThunk(
    GET_ALL_PREGUNTAS,
    async () => {
        try {
            const fullUrl = host + `Cuestionario/obtenerCuestionarios`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Vehiculos: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getPreguntasByCuestionario = createAsyncThunk(
    GET_ALL_PREGUNTAS_BY_CUESTIONARIO,
    async (idCuestionario) => {
        try {
            const fullUrl = host + `PreguntasCuestionario/obtenerPreguntasByCuestionario/${idCuestionario}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosCuestionarioSlice = createSlice({

    name: 'metodosCuestionarioSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllPreguntas.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.preguntas = payload.data.data

        },
        [getPreguntasByCuestionario.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.preguntas = payload.data.data
        },
        //[insertVehiculo.fulfilled]: (state, { payload }) => {
//
        //},
//
        //[updateVehiculo.fulfilled]: (state, { payload }) => {
//
        //},
        //[eliminarVehiculo.fulfilled]: (state, { payload }) => {
//
        //},

    },

})


export const { } = metodosCuestionarioSlice.actions
export const CuestionarioReducer = metodosCuestionarioSlice.reducer